export default __webpack_public_path__ + "images/86b304521135c933dbe07d3581a5ded9.png";